import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `${API_URLS.ROUTES}`;
const routePlanningPath = `${API_URLS.ROUTE_PLANNING}`;

// Corrigido: cálculo de rota vive no controller RoutePlanning, não em routes/route.
async function calculateRoute(payload) {
  const url = `${routePlanningPath}/calculate`;
  try {
    let response = await api.post(url, payload);
    let treated = errorHandling.handleResponse(response, "routingService.calculateRoute");
    if (treated) return treated;
    return null;
  } catch (error) {
    errorHandling.cathError(error, "routingService.calculateRoute");
    return null;
  }
}

// Corrigido: era /routes/vehicle-types (não existe). Endpoint real é route-planning/types.
async function fetchVehicleTypes() {
  const url = `${routePlanningPath}/types`;
  try {
    let response = await api.get(url);
    let treated = errorHandling.handleResponse(response, "routingService.fetchVehicleTypes");
    if (treated) return treated;
    return null;
  } catch (error) {
    errorHandling.cathError(error, "routingService.fetchVehicleTypes");
    return null;
  }
}


async function fetchAllRoutes() {
  const url = `${basePath}`;
  try {
    let response = await api.get(url);
    let treated = errorHandling.handleResponse(response, "routingService.fetchAllRoutes");
    if (treated) return treated;
    return null;
  } catch (error) {
    errorHandling.cathError(error, "routingService.fetchAllRoutes");
    return null;
  }
}

// GET /api/v3/vehicles/routes/{routeId}/detail
// Busca detalhes de uma rota específica
async function fetchRouteById(routeId) {
  const url = `${basePath}/${routeId}/detail`;
  try {
    let response = await api.get(url);
    let treated = errorHandling.handleResponse(response, "routingService.fetchRouteById");
    if (treated) return treated;
    return null;
  } catch (error) {
    errorHandling.cathError(error, "routingService.fetchRouteById");
    return null;
  }
}

// Corrigido: shape validado via curl — routeTypeId (int), startLocation/endLocation
// (endereço em texto), optimized, path, areaPath, mapLink, instructions.
async function createRoute(payload) {
  const url = `${basePath}`;
  try {
    let response = await api.post(url, payload);
    let treated = errorHandling.handleResponse(response, "routingService.createRoute");
    if (treated) return treated;
    return null;
  } catch (error) {
    errorHandling.cathError(error, "routingService.createRoute");
    return null;
  }
}

// NOVO: POST /routes/points — adiciona um ponto de passagem a uma rota já criada.
// payload: { routeId, order, address, latitude, longitude, visitPointId }
async function createRoutePoint(payload) {
  const url = `${basePath}/points`;
  try {
    let response = await api.post(url, payload);
    let treated = errorHandling.handleResponse(response, "routingService.createRoutePoint");
    if (treated) return treated;
    return null;
  } catch (error) {
    errorHandling.cathError(error, "routingService.createRoutePoint");
    return null;
  }
}

// NOVO: GET /routes/{routeId}/points — consulta os pontos de passagem de uma rota.
async function fetchRoutePoints(routeId) {
  const url = `${basePath}/${routeId}/points`;
  try {
    let response = await api.get(url);
    let treated = errorHandling.handleResponse(response, "routingService.fetchRoutePoints");
    if (treated) return treated;
    return null;
  } catch (error) {
    errorHandling.cathError(error, "routingService.fetchRoutePoints");
    return null;
  }
}

export const routingService = {
  calculateRoute,
  fetchVehicleTypes,
  fetchAllRoutes,
  fetchRouteById,
  createRoute,
  createRoutePoint,
  fetchRoutePoints,
};
